export const MODULE_ID_PUSH_MESSAGES = "VirtoCommerce.PushMessages";
export const MODULE_ID_XRECOMMEND = "VirtoCommerce.XRecommend";
export const XRECOMMEND_ENABLED_KEY = "XRecommend.RecommendationsEnabled";

export const APP_INSIGHTS_MODULE_ID = "VirtoCommerce.ApplicationInsights";
export const APP_INSIGHTS_ENABLE_STATE = "ApplicationInsights.EnableTracking";
export const APP_INSIGHTS_INSTRUMENTATION_KEY = "ApplicationInsights.InstrumentationKey";

export const MODULE_XAPI_KEYS = {
  MODULE_ID: "VirtoCommerce.Xapi",
  SUPPORT_PHONE_NUMBER: "Frontend.SupportPhoneNumber",
  PAGE_TITLE_WITH_STORE_NAME: "Frontend.PageTitleWithStoreName",
  PAGE_TITLE_STORE_NAME_ALIGN: "Frontend.PageTitleStoreNameAlign",
  PAGE_TITLE_DIVIDER: "Frontend.PageTitleDivider",
  CATALOG_MENU_LINK_LIST_NAME: "Frontend.CatalogMenuLinkListName",
  CATALOG_EMPTY_CATEGORIES_ENABLED: "Frontend.CatalogEmptyCategoriesEnabled",
  CONTINUE_SHOPPING_LINK: "Frontend.ContinueShoppingLink",
} as const;

// Innovadis custom
export const API_MANAGEMENT_MODULE = "Innovadis.ApiManagementModule";

export const ENABLE_PACK_SIZE_QUANTITY = "ApiManagementModule.StoreSettings.EnablePacksizeQuantity";
export const ENABLE_LENGTH_CONVERTER_SETTING = "ApiManagementModule.StoreSettings.EnableFenceLengthConverter";
export const ENABLE_SHOW_ANONYMOUS_PRICES = "ApiManagementModule.StoreSettings.ShowAnonymousCustomerPrices";
export const GENERAL_PRICE_LISTS = "ApiManagementModule.StoreSettings.GeneralPriceLists";
export const ENABLE_GENERAL_PRICE_LIST_EXCLUSION = "ApiManagementModule.StoreSettings.EnableGeneralPriceListExclusion";
export const CONTACT_MAIL_ADDRESS = "ApiManagementModule.StoreSettings.ContactEmailAddress";
export const MODULE_ID_SHIPPING = "VirtoCommerce.Shipping";
export const BOPIS_MAP_ENABLED_KEY = "Shipping.Bopis.GoogleMaps.Enabled";
export const BOPIS_MAP_API_KEY = "Shipping.Bopis.GoogleMaps.ApiKey";
